import SymmetricKey from "./SymmetricKey";

export default class EphemeralKey extends SymmetricKey {}
